import { render, staticRenderFns } from "./FooterBar.vue?vue&type=template&id=2de3aa87&"
import script from "./FooterBar.vue?vue&type=script&lang=ts&"
export * from "./FooterBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NavLinks: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/NavLinks.vue').default,SiteName: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/SiteName.vue').default,LinkExternal: require('/builds/simistry/gm/graduatemastery.com-nuxt/site/components/LinkExternal.vue').default})
